import React from 'react';
import briefingIcon from '../assets/images/stages/briefing.svg';
import prototypeIcon from '../assets/images/stages/prototype.svg';
import developmentIcon from '../assets/images/stages/development.svg';
import qaIcon from '../assets/images/stages/QA.svg';
import deployIcon from '../assets/images/stages/deploy.svg';
import approvalIcon from '../assets/images/stages/approved.svg';

const stages = [
  {
    number: "1",
    title: "Briefing",
    description: "Nesta fase inicial, discutimos detalhadamente suas necessidades, objetivos e restrições do projeto. Coletamos todas as informações essenciais para garantir uma base sólida para o desenvolvimento.",
    icon: briefingIcon
  },
  {
    number: "2",
    title: "Prototipagem",
    description: "Criamos um protótipo visual inicial do sistema, permitindo validar conceitos e ajustar funcionalidades com base no seu feedback antes de iniciar o desenvolvimento completo.",
    icon: prototypeIcon
  },
  {
    number: "3",
    title: "Desenvolvimento",
    description: "Agora, começamos a codificar e implementar as funcionalidades definidas, garantindo integração eficaz entre os componentes e mantendo uma colaboração contínua com você.",
    icon: developmentIcon
  },
  {
    number: "4",
    title: "QA (Garantia de Qualidade)",
    description: "Realizamos testes rigorosos para identificar e corrigir bugs, além de avaliar o desempenho geral do sistema, garantindo que o produto atenda aos padrões de qualidade exigidos.",
    icon: qaIcon
  },
  {
    number: "5",
    title: "Deploy",
    description: "Após a aprovação da QA, lançamos o sistema em produção, monitorando de perto o desempenho inicial e garantindo uma transição suave para o ambiente de uso real.",
    icon: deployIcon
  },
  {
    number: "6",
    title: "Aguardando Sua Aprovação",
    description: "Nesta fase final, implementamos os ajustes necessários e aguardamos sua aprovação final para concluir o projeto e garantir que tudo esteja de acordo com suas expectativas.",
    icon: approvalIcon
  }
];

const StageCard = ({ number, title, description, icon }) => (
  <div className="text-center">
    <div className="flex justify-center mb-8">
      <div className="w-[6rem] h-[6rem] bg-[#783BFF] rounded-full flex items-center justify-center overflow-hidden">
        <img src={icon} alt={title} className="scale-[2]" />
      </div>
    </div>
    <h3 className="text-white font-bold text-2xl mb-4">
      <span className="text-[#C6FF00]">{number} - </span>{title}
    </h3>
    <p className="text-white text-lg leading-relaxed px-4 max-w-sm mx-auto">
      {description}
    </p>
  </div>
);

const StagesComponent = ({ id }) => {
  return (
    <section className="bg-[#1C1B2D] py-12 px-4 " id={id}>
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl font-['ZenDots'] mb-4 text-center">
          <span className="text-white">Da Ideia à </span>
          <span className="text-[#C6FF00]">Solução Completa</span>
        </h2>
        <p className="text-white text-lg max-w-3xl sm:max-w-full mx-auto mb-16 text-center">
          Garantimos que sua solução tecnológica seja criada de forma eficiente, escalável e sob medida para o seu negócio.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16">
          {stages.map((stage) => (
            <StageCard
              key={stage.number}
              number={stage.number}
              title={stage.title}
              description={stage.description}
              icon={stage.icon}
            />
          ))}
        </div>

        <div className="text-center">
          <a
            href="/forms"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button 
              className="bg-[#C6FF00] text-[#151342] px-8 py-4 rounded-full text-lg lg:text-2xl font-semibold hover:bg-[#151342] hover:text-[#C6FF00] border-2 border-[#C6FF00] transition-colors duration-300 hover:scale-105 animate-pulse-border"
              onClick={() => window.location.href = '#contact'}
            >
              Solicitar um orçamento sem compromisso
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default StagesComponent;
